<div class="company accordion-container">
  @if (!companyDetailsValidated) {
    <com-banner-message [bannerMessageDetails]="validationBanner" width="100%"></com-banner-message>
  }
  <mat-accordion>
    <mat-expansion-panel #companyDetails [disabled]="!canEdit && componentUnderEdit !== 'company'" [expanded]="true">
      <mat-expansion-panel-header> Company Details </mat-expansion-panel-header>
      <acc-company-details
        [(company)]="company"
        [organisationTypes]="organisationTypes"
        [canEdit]="canEdit"
        (isEditing)="childIsEditing($event)"
      ></acc-company-details>
    </mat-expansion-panel>
    <mat-expansion-panel #contactPerson [disabled]="!canEdit && componentUnderEdit !== 'contact'">
      <mat-expansion-panel-header> Contact Person </mat-expansion-panel-header>
      <acc-contact-person
        [(company)]="company"
        [salutations]="salutations"
        [canEdit]="canEdit"
        (isEditing)="childIsEditing($event)"
      ></acc-contact-person>
    </mat-expansion-panel>
    <mat-expansion-panel #addressDetails [disabled]="!canEdit && componentUnderEdit !== 'address'">
      <mat-expansion-panel-header> Address Details </mat-expansion-panel-header>

      <acc-address-details
        [(company)]="company"
        [countries]="countries"
        [counties]="counties"
        [canEdit]="canEdit"
        (isEditing)="childIsEditing($event)"
      ></acc-address-details>
    </mat-expansion-panel>
  </mat-accordion>

  @if (!companyDetailsValidated) {
    <div class="company__box-button">
      <button mat-raised-button class="button--accent" (click)="validateCompanyDetails()" [disabled]="!canEdit">VALIDATE</button>
    </div>
  }
</div>
